var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import classnames from 'classnames';
import { Breadcrumb, BreadcrumbItem as PFBreadcrumbItem } from '@patternfly/react-core';
var Breadcrumbs = function (_a) {
    var _b = _a.items, items = _b === void 0 ? [] : _b, _c = _a.current, current = _c === void 0 ? null : _c, _d = _a.className, className = _d === void 0 ? '' : _d, _e = _a.onNavigate, onNavigate = _e === void 0 ? function () { return undefined; } : _e, props = __rest(_a, ["items", "current", "className", "onNavigate"]);
    console.warn("Breadcrumbs from FE component shouldn't be used anymore. \
Instead use https://patternfly-react.surge.sh/documentation/react/components/breadcrumb from PF repository.");
    return (React.createElement(Breadcrumb, __assign({ className: classnames('ins-c-breadcrumbs', className) }, props),
        items.map(function (oneLink, key) { return (React.createElement(PFBreadcrumbItem, { key: key, "data-key": key },
            React.createElement("a", { onClick: function (event) { return onNavigate(event, oneLink.navigate, key); }, "aria-label": oneLink.navigate }, oneLink.title))); }),
        current && React.createElement(PFBreadcrumbItem, { isActive: true },
            " ",
            current,
            " ")));
};
export default Breadcrumbs;
//# sourceMappingURL=Breadcrumbs.js.map